var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StatisticsTable"},[(_vm.nowPage == '歷史參數查詢')?[_c('heatTreatmentInquire')]:(_vm.nowPage == '統計分析')?[_c('heatTreatmentAnalysis')]:(_vm.nowPage == '自主檢驗超時')?[_c('inspectTimeout')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d519f1f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/StatisticsTable.vue
// module id = null
// module chunks = 